export default __webpack_public_path__ + "83e26369ba6150aa86bc8c7a9e68459f.png";